// Tool input arrives as JSON fragments, so a single field is often readable long before the
// object around it is valid JSON. `complete` says whether the closing quote has arrived.
export type PartialString = { value: string; complete: boolean };

export function readPartialJsonString(partial_json: string, key: string): PartialString | null {
    const opening = new RegExp(`"${key}"\\s*:\\s*"`).exec(partial_json);
    if (!opening) return null;

    let raw = "";
    let complete = false;

    for (let i = opening.index + opening[0].length; i < partial_json.length; i++) {
        const char = partial_json[i];

        if (char === "\\") {
            raw += char + (partial_json[i + 1] ?? "");
            i++;
            continue;
        }

        if (char === '"') {
            complete = true;
            break;
        }

        raw += char;
    }

    return { value: decodeStringBody(raw), complete };
}

// Strict tools take their operation payload as a JSON *string*, so its keys arrive escaped one
// level deeper. Unescape the outer value first, then read the key out of the fragment.
export function readPartialNestedJsonString(partial_json: string, outer_key: string, inner_key: string): PartialString | null {
    const outer = readPartialJsonString(partial_json, outer_key);
    if (!outer) return null;

    return readPartialJsonString(outer.value, inner_key);
}

function decodeStringBody(raw: string): string {
    // A fragment can end mid-escape, which is not decodable on its own.
    const decodable = raw.replace(/\\(u[0-9a-fA-F]{0,3})?$/, "");

    try {
        return JSON.parse(`"${decodable}"`);
    } catch {
        return decodable;
    }
}
